var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.087 9.17359C20.256 9.17359 22.3361 9.9634 23.8697 11.3693C25.4033 12.7751 26.265 14.6819 26.265 16.6701C26.2702 18.1457 25.7943 19.5891 24.8988 20.8152L26.265 24.1665L21.6661 23.4081C20.56 23.9025 19.3466 24.1618 18.1161 24.1665C16.8856 24.1713 15.6698 23.9213 14.5593 23.4356C13.4488 22.9498 12.4722 22.2404 11.7022 21.3606C10.9323 20.4807 10.3889 19.4529 10.1126 18.3537C9.8362 17.2546 9.83396 16.1124 10.1061 15.0124C10.3782 13.9123 10.9176 12.8828 11.6841 12.0004C12.4506 11.118 13.4244 10.4055 14.533 9.91609C15.6417 9.42665 16.8565 9.17284 18.087 9.17359Z",
    stroke: "#34220F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2608 4.78168C17.965 3.27016 16.1872 2.16665 14.1751 1.62477C12.163 1.0829 10.0166 1.12964 8.03475 1.75848C6.05295 2.38732 4.33438 3.56697 3.11829 5.13318C1.90221 6.69938 1.24916 8.57422 1.25004 10.4966C1.24408 12.324 1.83373 14.1114 2.94336 15.6295L1.25004 19.7569L5.3294 19.0866",
    stroke: "#34220F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeChat);
export default __webpack_public_path__ + "static/media/home-chat.4cdc5a576dfe1ccd62098bc24887b173.svg";
export { ForwardRef as ReactComponent };